export default class PasswordStrengthMeter {
    #passwordElement
    #measureElement

    #maxStrength = 10

    constructor(element) {
        this.#passwordElement = element
        this.#measureElement = document.querySelector(element.dataset.gpTarget)

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(
            document.querySelectorAll(selector),
            (element) => new PasswordStrengthMeter(element)
        )
    }

    #bindEvents() {
        this.#passwordElement.addEventListener('keyup', () => {
            this.#handleChange()
        })
    }

    #handleChange() {
        let strength = PasswordStrengthMeter.determineStrength(this.#passwordElement.value)
        let strengthPercentage = this.#determineStrengthPercentage(strength)

        this.#measureElement.setAttribute('aria-valuenow', strengthPercentage)
        this.#measureElement.style.width = strengthPercentage + '%'
        this.#measureElement.classList.toggle('bg-danger', false)
        this.#measureElement.classList.toggle('bg-warning', false)
        this.#measureElement.classList.toggle('bg-success', false)
        this.#measureElement.classList.toggle(
            PasswordStrengthMeter.determineStrengthBackground(strength),
            true
        )
    }

    #determineStrengthPercentage(strength) {
        return (strength / this.#maxStrength) * 100
    }

    static determineStrength(password) {
        let strength = 0

        if (password.length > 8) {
            strength += password.length > 12 ? 2 : 1
        }

        const upperCaseRegex = new RegExp('[A-Z]')
        if (upperCaseRegex.test(password)) {
            strength += 2
        }

        const lowerCaseRegex = new RegExp('[a-z]')
        if (lowerCaseRegex.test(password)) {
            strength += 2
        }

        const digitRegex = new RegExp('[0-9]')
        if (digitRegex.test(password)) {
            strength += 2
        }

        const symbolRegex = new RegExp('^[a-zA-Z0-9]')
        if (symbolRegex.test(password)) {
            strength += 2
        }

        return strength
    }

    static determineStrengthBackground(strength) {
        if (strength < 7) {
            return 'bg-danger'
        }
        if (strength <= 8) {
            return 'bg-warning'
        }
        return 'bg-success'
    }
}
